// extracted by mini-css-extract-plugin
module.exports = {"apartmentFolders":"ApartmentFolders_apartmentFolders__1YraS","folderHeader":"ApartmentFolders_folderHeader__1vmRO","folderList":"ApartmentFolders_folderList__1yftL"};